<v-container fluid class="login-container fill-height">
    <v-row justify="center" align="center">
        <v-col cols="12" sm="8" md="4" lg="3">

            <v-card class="login-card elevation-8">

                <v-card-text class="pa-6">

                    <div class="text-center mb-6 d-flex flex-column align-center">
                        <v-img :src="require('@/assets/logo.png')" width="72" height="75" />
                        <div class="text-h5 font-weight-bold mt-2">Rilievi Misure</div>
                        <div class="text-caption text-medium-emphasis">Accesso al gestionale</div>
                    </div>

                    <!-- ── Form login ───────────────────────────────────── -->
                    <v-form ref="formLogin" @submit.prevent="submit()">

                        <v-text-field v-model="cred.username" prepend-inner-icon="mdi-account" label="Utente"
                            variant="outlined" density="comfortable"
                            :rules="[() => cred.username.length > 0 || 'Il campo utente è obbligatorio']" autofocus
                            required />

                        <v-text-field v-model="cred.password" prepend-inner-icon="mdi-lock" label="Password"
                            variant="outlined" density="comfortable" :type="e1 ? 'password' : 'text'"
                            :append-inner-icon="e1 ? 'mdi-eye' : 'mdi-eye-off'" @click:append-inner="e1 = !e1"
                            :rules="[() => cred.password.length > 0 || 'Il campo password è obbligatorio']" required />

                        <v-btn block size="large" color="primary" class="mt-4" type="submit" :loading="attesa"
                            :disabled="attesa">
                            Accedi
                        </v-btn>

                    </v-form>

                    <!-- ── Link password dimenticata ────────────────────── -->
                    <div class="text-center mt-4">
                        <v-btn variant="text" size="small" color="primary" @click="apriResetPassword">
                            Password dimenticata?
                        </v-btn>
                    </div>

                </v-card-text>
            </v-card>

            <div class="text-center text-caption mt-4 text-medium-emphasis">
                Sistema gestione rilievi
            </div>

        </v-col>
    </v-row>

    <!-- ── Dialog reset password ──────────────────────────────────────────── -->
    <v-dialog v-model="dialogReset" max-width="420" persistent>
        <v-card rounded="lg">

            <v-card-title class="d-flex align-center pa-4">
                <v-icon icon="mdi-lock-reset" color="primary" class="mr-2" />
                Recupero password
                <v-spacer />
                <v-btn icon="mdi-close" variant="text" @click="chiudiReset" />
            </v-card-title>

            <!-- step 1: inserimento email -->
            <template v-if="resetStep === 1">
                <v-card-text class="pa-4 pt-0">
                    <p class="text-body-2 text-medium-emphasis mb-4">
                        Inserisci l'indirizzo email associato al tuo account.
                        Riceverai un link per reimpostare la password.
                    </p>
                    <v-form ref="formReset">
                        <v-text-field v-model="resetEmail" label="Indirizzo email" prepend-inner-icon="mdi-email"
                            variant="outlined" density="compact" :rules="[
                                v => !!v || 'Campo obbligatorio',
                                v => /.+@.+\..+/.test(v) || 'Email non valida'
                            ]" autocomplete="email" @keyup.enter="inviaReset" />
                    </v-form>
                </v-card-text>
                <v-card-actions class="pa-4 pt-0">
                    <v-spacer />
                    <v-btn variant="text" @click="chiudiReset">Annulla</v-btn>
                    <v-btn color="primary" variant="elevated" :loading="attesaReset" @click="inviaReset">
                        Invia link
                    </v-btn>
                </v-card-actions>
            </template>

            <!-- step 2: conferma invio -->
            <template v-if="resetStep === 2">
                <v-card-text class="pa-4 pt-0 text-center">
                    <v-icon icon="mdi-email-check" color="success" size="56" class="mb-3" />
                    <p class="text-body-1 font-weight-medium mb-1">Email inviata</p>
                    <p class="text-body-2 text-medium-emphasis">
                        Se l'indirizzo <strong>{{ resetEmail }}</strong> è associato a un account,
                        riceverai a breve il link per reimpostare la password.
                    </p>
                </v-card-text>
                <v-card-actions class="pa-4 pt-0">
                    <v-spacer />
                    <v-btn color="primary" variant="elevated" @click="chiudiReset">Chiudi</v-btn>
                </v-card-actions>
            </template>

        </v-card>
    </v-dialog>

</v-container>